import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlus } from '@fortawesome/free-solid-svg-icons';
import ModalPesquisarProdutosSngpc from 'pages/sngpc/components/ModalPesquisarProdutosSngpc';
import { ProdutoParaInventarioType } from '../../../../data/sngpc';
import { useBreakpoints } from 'providers/BreakpointsProvider';

interface BotaoPesquisarProdutosProps {
    onProdutoSelecionado: (produto: ProdutoParaInventarioType) => void;
    disabled?: boolean;
}

const BotaoPesquisarProdutos: React.FC<BotaoPesquisarProdutosProps> = ({
    onProdutoSelecionado,
    disabled = false
}) => {
    const [showModal, setShowModal] = useState(false);
    const { breakpoints } = useBreakpoints();
    const isMobile = breakpoints.down('md');

    const handleSelecionar = (produto: ProdutoParaInventarioType) => {
        onProdutoSelecionado(produto);
        setShowModal(false);
    };

    return (
        <>
            <Button
                variant="primary"
                onClick={() => setShowModal(true)}
                disabled={disabled}
                className={isMobile ? 'flex-fill' : ''}
            >
                <FontAwesomeIcon icon={isMobile ? faPlus : faSearch} className="me-2" />
                {isMobile ? 'Incluir' : 'Pesquisar e Incluir Produtos'}
            </Button>

            <ModalPesquisarProdutosSngpc
                show={showModal}
                onHide={() => setShowModal(false)}
                onSelecionarProduto={handleSelecionar}
            />
        </>
    );
};

export default BotaoPesquisarProdutos; 